import type { WiwState } from '@/store';

export const getStateUsers = (state: WiwState) => state.data.user.items;
